import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as t } from "../../../components/TextSkeleton/index.js";
import { generateIndexArray as l } from "../../../services/utils/index.js";
import { HotDealCardSkeleton as n } from "../HotDealCard/skeleton.js";
import { HotDealsContainerSkeleton as a, HotDealsHeaderSkeleton as i, HotDealsCarouselTitle as s, HotDealsCarouselDescription as m, HotDealsCarouselContainerSkeleton as d, HotDealsCarouselListSkeleton as p } from "./style.js";
function C() {
  return /* @__PURE__ */ o(a, { animate: !0, children: [
    /* @__PURE__ */ o(i, { children: [
      /* @__PURE__ */ e(s, { children: /* @__PURE__ */ e(t, { width: "184px" }) }),
      /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e(t, { width: "234px" }) })
    ] }),
    /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(p, { children: l(6).map((r) => /* @__PURE__ */ e(n, {}, r)) }) })
  ] });
}
export {
  C as HotDealsCarouselSkeleton
};
